import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-sm text-slate-500">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    // Redirection contextuelle : si la route concerne un parcours spécialiste,
    // on envoie vers /register?role=expert plutôt que /login → évite le
    // « lien cassé » ressenti sur « Vous n'êtes pas encore référencé ? ».
    const path = location.pathname + location.search;
    const isExpertRoute = path.startsWith("/expert/");
    const redirect = isExpertRoute ? "/register?role=expert" : "/login";
    return <Navigate to={redirect} state={{ from: path }} replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
